module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/flag/flag-normal-196.png"+" 196w",
        images: [{path: __webpack_public_path__ + "assets/images/flag/flag-normal-196.png",width: 196,height: 235}],
        src: __webpack_public_path__ + "assets/images/flag/flag-normal-196.png",
        toString: function(){return __webpack_public_path__ + "assets/images/flag/flag-normal-196.png"},
        
        width: 196,
        height: 235
      }